import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetWageSupplementLumpSum,
  SaveWageSupplementLumpSum,
  CreateWageSupplementLumpSum,
  DeleteWageSupplementLumpSum,
  GetWageSupplementLumpSumById
};

function GetWageSupplementLumpSum(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/wagesupplementlumpsumtype`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        onError(error.response.data);
      } else if (error.request) {
        onError(error.response);
      } else {
        onError(error.message);
      }
      onError(error.config);
    });
}

function SaveWageSupplementLumpSum(wageSuppLumpSumObj, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/wagesupplementlumpsumtype`,
      wageSuppLumpSumObj,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function CreateWageSupplementLumpSum(wageSuppLumpSumObj, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/wagesupplementlumpsumtype`,
      wageSuppLumpSumObj,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteWageSupplementLumpSum(wageSuppLumpSumId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementlumpsumtype/${wageSuppLumpSumId}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetWageSupplementLumpSumById(wageSuppLumpSumObj, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/wagesupplementlumpsumtype/${wageSuppLumpSumObj.id}`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}
